module.exports = __webpack_public_path__ + "img/1048_help_title_en_0e248f57f.png";